import {ItemStatus, ItemType} from "../enums/item-enums";

export default class Workflow {

    /***
     *
     * @param{[Item]} itemList
     */
    static getInstanceFromItemList(itemList) {
        // TODO : we are not getting the updated itemList here
        let totalBagCount = 0;
        let completedBagCount = 0;
        let totalOVCount = 0;
        let completedOVCount = 0;
        let totalMissingItems = 0;
        let completedMissingItems = 0;
        let tempMissingBagCount = 0;
        let tempMissingOVCount = 0;
        let pickedBagCount = 0;
        let pickedOVCount = 0;

        itemList && Array.isArray(itemList) && itemList.forEach(item => {
            const {itemType, itemStatus} = item;
            if (ItemType.isBag(itemType)) {
                totalBagCount++;
                ItemStatus.isCompleted(itemStatus) && completedBagCount++;
                ItemStatus.isTempMissing(itemStatus) && tempMissingBagCount++;
                ItemStatus.isPicked(itemStatus) && pickedBagCount++;
            }

            if (ItemType.isPackage(itemType)) {
                totalOVCount++;
                ItemStatus.isCompleted(itemStatus) && completedOVCount++;
                ItemStatus.isTempMissing(itemStatus) && tempMissingOVCount++;
                ItemStatus.isPicked(itemStatus) && pickedOVCount++;
            }
            if (ItemStatus.isMissingEver(item.isMissedEver, itemStatus)) {
                totalMissingItems++;
                !ItemStatus.isTempMissing(itemStatus) && completedMissingItems++
            }
        });

        const workflowProgress = new Workflow();
        workflowProgress.totalItems = itemList.length;
        workflowProgress.totalBagCount = totalBagCount;
        workflowProgress.completedBagCount = completedBagCount;
        workflowProgress.totalOVCount = totalOVCount;
        workflowProgress.completedOVCount = completedOVCount;
        workflowProgress.totalMissingItems = totalMissingItems;
        workflowProgress.completedMissingItems = completedMissingItems;
        workflowProgress.tempMissingBagCount = tempMissingBagCount;
        workflowProgress.tempMissingOVCount = tempMissingOVCount;
        workflowProgress.pickedBagCount = pickedBagCount;
        workflowProgress.pickedOVCount = pickedOVCount;

        return workflowProgress;

    }

    /***
     *
     * @param{PickProgress} pickingProgress
     */
    static getInstanceFromPickingProgress(pickingProgress) {
        // TODO
        const workflow = new Workflow();
        workflow.totalItems = pickingProgress.totalItemsCount;
        // workflow.totalBagCount = pickingProgress.;
        // workflow.completedBagCount = pickingProgress.;
        // workflow.totalOVCount = pickingProgress.;
        // workflow.completedOVCount = pickingProgress.;
        // workflow.totalMissingItems = pickingProgress.;
        // workflow.completedMissingItems = pickingProgress.;
        // workflow.tempMissingBagCount = pickingProgress.;
        // workflow.tempMissingOVCount = pickingProgress.;
        // workflow.pickedBagCount = pickingProgress.;
        // workflow.pickedOVCount = pickingProgress.;
        return workflow;
    }

    constructor() {
        this.totalItems = 20;
        this.totalBagCount = 5;
        this.completedBagCount = 3;
        this.totalOVCount = 15;
        this.completedOVCount = 5;
        this.totalMissingItems = 20;
        this.completedMissingItems = 20;
        this.tempMissingBagCount = 20;
        this.tempMissingOVCount = 20;
        this.pickedBagCount = 3;
        this.pickedOVCount = 5;
    }
}




// WEBPACK FOOTER //
// ./src/models/ui/workflow.js